import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const StarSolid = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      stroke="currentColor"
      d="M17.132 21.002a.7.7 0 0 1-.325-.084l-4.806-2.647-4.807 2.647a.67.67 0 0 1-.735-.056.75.75 0 0 1-.278-.714l.918-5.606-3.888-3.97a.76.76 0 0 1-.176-.748.71.71 0 0 1 .562-.497l5.375-.818 2.403-5.1A.7.7 0 0 1 12 3.002c.265 0 .508.158.625.407l2.403 5.1 5.375.818c.262.04.48.232.562.497a.76.76 0 0 1-.176.749l-3.889 3.97.919 5.605a.75.75 0 0 1-.278.714.67.67 0 0 1-.41.14"
      clipRule="evenodd"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(StarSolid) as SvgIcon;
export { ForwardRef as ReactComponent };
